import { useQuery, useMutation } from '@tanstack/react-query'
import {
  bukuTamuApi,
  type BukuTamuCreateInput,
  type PejabatDropdownItem,
} from '../../../shared-lib'

export const usePejabatDropdown = () => {
  return useQuery({
    queryKey: ['buku-tamu', 'pejabat'],
    queryFn: async () => {
      const response = await bukuTamuApi.getPejabatList()
      return response.data as PejabatDropdownItem[]
    },
    staleTime: 5 * 60 * 1000,
    retry: 2,
  })
}

export const useSubmitBukuTamu = () => {
  return useMutation({
    mutationFn: async (data: BukuTamuCreateInput[]) => {
      const response = await bukuTamuApi.submit(data)
      return response.data
    },
  })
}
